import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import classes from './InstructorList.module.scss';

const InstructorList = (props) => {
  const {
    items = [],
  } = props;

  return (
    items.length > 0 &&
      <div className={classes.container}>
        {items.map((item, i) => (
          <div
            className={classes.item}
            key={`${item}-item-${i}`}
          >
            {BuildChildren(item)}
          </div>
        ))}
      </div>
  );
};

InstructorList.propTypes = {
  /**
   * List of Instructors
  */
  items: PropTypes.array,
};

export default InstructorList;
